import axios from 'axios';
import qs from 'qs';

export const getTwoColumnsLessonById = ({
  lessonId,
  locale,
}: {
  lessonId: string;
  locale?: string;
}) =>
  axios.get(
    `/api/v1/two-columns-lessons/${lessonId}${locale ? `?${qs.stringify({ locale })}` : ''}`,
  );

export const createTwoColumnsLesson = (data: any) =>
  axios.post('/api/v1/two-columns-lessons', data);

export const updateTwoColumnsLessonById = ({
  lessonId,
  data,
}: {
  lessonId: string;
  data: any;
}) => axios.put(`/api/v1/two-columns-lessons/${lessonId}`, data);

export const removeTwoColumnsLessonById = (lessonId: string) =>
  axios.delete(`/api/v1/two-columns-lessons/${lessonId}`);
